import type { Lesson } from '@/hooks/useDashboardData';
import { getWeekdayShort, getDayNumber } from '@/lib/date';

interface UpcomingWeekProps {
  lessons: Lesson[];
}

function getTodayStr() {
  return new Date().toISOString().slice(0, 10);
}

function getNext7Days(): string[] {
  const days: string[] = [];
  const today = new Date();
  for (let i = 0; i < 7; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    days.push(d.toISOString().slice(0, 10));
  }
  return days;
}

export default function UpcomingWeek({ lessons }: UpcomingWeekProps) {
  const today = getTodayStr();
  const weekDates = getNext7Days();

  return (
    <div className="grid grid-cols-7 gap-2">
      {weekDates.map((date) => {
        const dayLessons = lessons.filter((l) => l.date === date);
        const isToday = date === today;
        return (
          <div
            key={date}
            className={`flex flex-col items-center rounded-xl border p-3 text-center transition ${
              isToday ? 'border-primary-300 bg-primary-50' : 'border-background-200 bg-white'
            }`}
          >
            <span className={`text-xs font-semibold ${isToday ? 'text-primary-700' : 'text-foreground-500'}`}>
              {getWeekdayShort(date)}
            </span>
            <span
              className={`mt-1.5 flex h-9 w-9 items-center justify-center rounded-full font-heading text-sm font-bold ${
                isToday ? 'bg-primary-500 text-white' : 'text-foreground-900'
              }`}
            >
              {getDayNumber(date)}
            </span>
            {dayLessons.length > 0 ? (
              <div className="mt-2 flex items-center gap-1">
                {dayLessons.slice(0, 3).map((l) => (
                  <span key={l.id} className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                ))}
              </div>
            ) : (
              <span className="mt-2 text-[10px] text-foreground-300">—</span>
            )}
            {dayLessons.length > 0 && (
              <span className="mt-1 text-[10px] font-medium text-foreground-600">{dayLessons.length} ders</span>
            )}
          </div>
        );
      })}
    </div>
  );
}